import { requests } from "../config";
import { IPostTableSelect } from "./models/postTableSelect";

export const TableSelect = {
    getExistingRow: (tableID: number) => requests.get(`temp_tbl_select?TableID=${tableID}`, 'go'),
    postRows: (id: number, data: IPostTableSelect[]) => requests.post(`temp_tbl_select?TableID=${id}`, 'go', data)
}